"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var bson_1 = require("bson");
var buffer_1 = require("buffer");
var crypto = require("crypto");
var events_1 = require("events");
var util_1 = require("./util");
var EventCryptor = /** @class */ (function (_super) {
    __extends(EventCryptor, _super);
    function EventCryptor(paste, passwordSize) {
        if (passwordSize === void 0) { passwordSize = 32; }
        var _this = _super.call(this) || this;
        _this.paste = paste;
        _this.passwordSize = passwordSize;
        return _this;
    }
    EventCryptor.prototype.run = function () {
        var _this = this;
        var data = this.paste.serialize();
        var password = util_1.randomPassword(this.passwordSize);
        var payload = {
            data: null,
            iterations: 10000,
            salt: crypto.randomBytes(8),
            version: 2,
        };
        var key = crypto.pbkdf2Sync(password, payload.salt, payload.iterations, 5, 'sha512');
        var encrypted;
        this.cipher = crypto.createCipher('aes256', key);
        this.cipher.on('readable', function () {
            var part = _this.cipher.read();
            if (part) {
                if (encrypted) {
                    encrypted = buffer_1.Buffer.concat([encrypted, part]);
                }
                else {
                    encrypted = part;
                }
                // Allocated size of buffer / original buffer size
                _this.emit('progress', encrypted.length / data.length);
            }
        });
        this.cipher.on('end', function () {
            var bson = new bson_1.BSON();
            _this.emit('complete', {
                data: bson.serialize(__assign({}, payload, { data: encrypted })),
                key: password,
            });
        });
        // smooth out progress bar
        var chunkSize = 512 * 1024;
        if (data.length <= chunkSize) {
            this.cipher.write(data);
        }
        else {
            for (var offset = 0; offset < data.length; offset += chunkSize) {
                var end = offset + chunkSize;
                this.cipher.write(data.slice(offset, end > data.length ? data.length : end));
            }
        }
        this.cipher.end();
    };
    return EventCryptor;
}(events_1.EventEmitter));
exports.default = EventCryptor;
